// issue 121 / ADR-112 决策 5（UAT r1 修订 U1.3，2026-10-21 Addison）：
// 「我的 Deal Book」挂在一级菜单 14「Deal Book」下，Sponsor 只要持 113 的 Deal Book-编辑 / 只读（1001015 / 1001016）
// 就能看到，不用另授菜单权限。后端 get_user_action_permission 只返回角色实际绑定的码（msfund-system 只读不改），
// 所以在前端拿到权限列表后补出这两条菜单；后端 my/* 接口的 canFillMy 同口径放行这两点。
// 码与 docs/issues/121-post-investment-schema.sql 钉死；synthetic 行的字段照 tbl_menu 行（translateDataToTree / BasicLayout 要用）。
export const MENU_DEAL_BOOK = '14'
export const MENU_MY_DEAL_BOOK = '1208'
export const PERM_DEAL_BOOK_EDIT = '1001015' // 113：Deal Book-编辑（UAT r2 U2.1 起挂 1208 我的 Deal Book 下，原挂 1001 项目详情）
export const PERM_DEAL_BOOK_VIEW = '1001016' // 113：Deal Book-只读（同上）
const DEAL_BOOK_CHILD_MENUS = ['1401', '1402', MENU_MY_DEAL_BOOK] // 14 下的子菜单（投后工作台 / 投前工作台 / 我的 Deal Book）

export interface IMenuPermission {
  code: string
  parent_code: string
  name_zh: string
  path: string
  type: number
  visibility: number
  priority: number
  [k: string]: any
}

// 一级菜单 14 排在「人事管理」页签内最后（绩效管理之后）：取现有一级菜单最大 priority + 1，与 presys tbl_menu 的 UPDATE 同口径
const topPriority = (list: IMenuPermission[]) =>
  list.reduce((mx, i) => (i.parent_code === '0' && i.priority > mx ? i.priority : mx), 0) + 1

// opts.filler：本人是某张已推送单子的填写人（my/list 非空）。被指定填写人可以是任何在职员工、不一定持权限点（presys 自测 S2）
export function withDerivedDealBookMenus(
  permission: IMenuPermission[],
  opts: { filler?: boolean } = {}
): IMenuPermission[] {
  const list = permission || []
  const has = (code: string) => list.some(i => i.code === code)
  const sponsor = has(PERM_DEAL_BOOK_EDIT) || has(PERM_DEAL_BOOK_VIEW) || !!opts.filler
  // 自测 S1（2026-10-22）：角色权限管理里只勾功能点时 ModalRole 不存半勾的父级 14（只把所在菜单放进 checkedKeys），
  // 1401 / 1402 / 1208 没有 14 会被 translateDataToTree 丢掉——有任一子菜单就补 14
  const child = DEAL_BOOK_CHILD_MENUS.some(has)
  if (!sponsor && !child) {
    return list
  }
  const out = [...list]
  if (!has(MENU_DEAL_BOOK)) {
    out.push({
      code: MENU_DEAL_BOOK,
      parent_code: '0',
      name_zh: 'Deal Book',
      name_en: 'deal_book',
      path: '/deal_book',
      type: 1,
      visibility: 1,
      priority: topPriority(list),
      icon: 'icon-list',
      is_enable: 1
    })
  }
  if (sponsor && !has(MENU_MY_DEAL_BOOK)) {
    out.push({
      code: MENU_MY_DEAL_BOOK,
      parent_code: MENU_DEAL_BOOK,
      name_zh: '我的 Deal Book',
      name_en: 'my_deal_book',
      path: '/deal_book/my_deal_book',
      type: 1,
      visibility: 1,
      priority: 3, // 1401 / 1402 之后
      is_enable: 1
    })
  }
  return out
}

// 推导后仍没有「我的 Deal Book」→ 需要再问一次 my/list 看本人是不是被指定的填写人（models/user.ts 的 watchDealBookFiller）
export function needsFillerCheck(permission: IMenuPermission[]): boolean {
  return !withDerivedDealBookMenus(permission).some(i => i.code === MENU_MY_DEAL_BOOK)
}
